import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bordered-card bordered-card_secondary gap-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold" }, "Reports", -1)
const _hoisted_3 = { class: "d-flex gap-10 w-100 flex-md-row flex-column" }
const _hoisted_4 = {
  key: 0,
  class: "bordered-card bordered-card_secondary justify-content-between pdt-25 pdb-25 gap-25 flex-xxl-row flex-wrap"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-start gap-10 flex-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-bold" }, "Reports from Fund Office "),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Demographic Request Report ")
], -1)
const _hoisted_6 = { class: "bordered-card bordered-card_secondary justify-content-between pdt-25 pdb-25 gap-25 flex-xxl-row flex-wrap" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-start gap-10 flex-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-bold" }, "Submit ACA Mandate Request")
], -1)
const _hoisted_8 = { class: "bordered-card bordered-card_secondary justify-content-between pdt-25 pdb-25 gap-25 flex-xxl-row flex-wrap" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-start gap-10 flex-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-bold" }, "Download Health Coverage Report ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.demographicReport)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("a", {
              class: "btn btn-primary plan-modal border-radius-8 pdl-30 pdr-30 w-sm-100 w-fit flex-1",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal('smartsearch', null, 'modal-success', null, { DocumentID: _ctx.demographicReport })), ["prevent"]))
            }, " Download ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("a", {
          href: "javascript;",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('employer-aca-report', 'Employee Health Coverage Information Request', null, null, null, null, null, { download: '0' })), ["prevent"])),
          class: "plan-modal btn btn-primary border-radius-8 pdl-30 pdr-30 w-sm-100 w-fit flex-1"
        }, " Submit ")
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("a", {
          href: "javascript;",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openModal('employer-aca-report', 'Employee Health Coverage Information Request', null, null, null, null, null, { download: '1' })), ["prevent"])),
          class: "plan-modal btn btn-primary border-radius-8 pdl-30 pdr-30 w-sm-100 w-fit flex-1"
        }, " Download ")
      ])
    ])
  ]))
}